/**
 * 获取是否播放一次的值
 */
exports.getOneTime = vid => {
  let timestamp = 'huya_' + Date.now()
  let onetime = sessionStorage.getItem(vid+'-report')
  if (!onetime) {
    onetime = timestamp
    sessionStorage.setItem(vid+'-report', onetime)
  }
  return onetime
}